import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useTypedParams } from 'react-router-typesafe-routes';
import ForwardForm from '@/components/scan-code/forward-form';
import useBatchForward, { type ForwardTarget } from '@/hooks/forward/use-batch-forward';
import useUserPlatform from '@/hooks/use-user-platform';
import ROUTES from '@/routes';

export default function CollectionForwardRoute() {
  const { collectionId } = useTypedParams(ROUTES.MY.COLLECTIONS.BY_ID);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { mutateAsyncWithPrompt: forwardCollections, isPending: isForwarding } = useBatchForward();
  const { isDesktop } = useUserPlatform();
  const handleForward = async (targets: ForwardTarget[], clearSelection: () => void) => {
    if (await forwardCollections({ collectionIds: [collectionId], targets })) {
      navigate(-1);
    } else {
      clearSelection();
    }
  };

  return (
    <ForwardForm
      navigateBack={!isDesktop}
      onForward={handleForward}
      isLoading={isForwarding}
      title={t('conversation.forward.title')}
    />
  );
}
